import { useState } from 'react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import { UMSidebar } from '../_components';
import type { SidebarMenu } from '../_components';
import { useJourneyLayers } from './hooks';
import { JourneyPanel } from './JourneyPanel';
import { TopBar } from './TopBar';

export const meta = {
  title: 'Menu des couches — Parcours',
  description: 'Piste B : le panel "Couches" est organisé par les 5 étapes du parcours d\'étude (Consommation, Ressources, Tracé, Futur, Contexte), sans favoris. Toutes les couches restent accessibles.',
  tags: ['map', 'territory', 'po'],
  author: 'clemence.fandard',
  status: 'draft' as const,
};

export default function MenuCouchesParcours() {
  const [activeMenu, setActiveMenu] = useState<SidebarMenu | null>('layers');
  const state = useJourneyLayers();

  const handleToggleMenu = (menu: SidebarMenu) => {
    setActiveMenu((prev) => (prev === menu ? null : menu));
  };

  return (
    <PrototypeStudioLayout title="UrbanMap — Menu des couches (Parcours)">
      <div style={{ display: 'flex', width: '100%', height: 'calc(100vh - 56px)', overflow: 'hidden' }}>

        <UMSidebar activeMenu={activeMenu} onToggleMenu={handleToggleMenu} />

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
          <TopBar />

          <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
            {activeMenu === 'layers' && (
              <JourneyPanel
                steps={state.steps}
                layersByStep={state.layersByStep}
                visible={state.visible}
                openStep={state.openStep}
                search={state.search}
                activeCount={state.activeCount}
                onSearch={state.setSearch}
                onToggleVisible={state.toggleVisible}
                onToggleStep={state.toggleStep}
                onClearAll={state.clearAll}
                onClose={() => setActiveMenu(null)}
              />
            )}

            <main style={{
              flex: 1, background: '#e8ecf0',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexDirection: 'column', gap: 8,
              color: '#94a3b8', fontSize: 14,
            }}>
              <span style={{ fontSize: 40 }}>🗺</span>
              <span>Carte Mapbox (placeholder)</span>
              <span style={{ fontSize: 12 }}>
                {state.activeCount === 0
                  ? 'Aucune couche activée pour le moment'
                  : `${state.activeCount} couche${state.activeCount > 1 ? 's' : ''} activée${state.activeCount > 1 ? 's' : ''} s'afficherai${state.activeCount > 1 ? 'ent' : 't'} ici`}
              </span>
            </main>
          </div>
        </div>

      </div>
    </PrototypeStudioLayout>
  );
}
